// TODO: zaprojektować multi-select wariant Combobox z chipami zaznaczonych
// wartości. Aktualnie zostaje native <select multiple>. Follow-up:
// [[followup_combobox_unification]] w MEMORY.md.
import { inputCommon } from '../inputCommon'
import type { FieldInputProps } from '../types'

export function MultiSelectInput({ field, value, onChange, disabled }: FieldInputProps) {
  const selected: string[] = Array.isArray(value) ? value.map(String) : []
  return (
    <select
      id={`field-${field.fieldCode}`}
      multiple
      className={`${inputCommon(disabled)} h-auto min-h-[6rem]`}
      disabled={disabled}
      value={selected}
      onChange={e => onChange(Array.from(e.target.selectedOptions, o => o.value))}
    >
      {field.options.map(o => (
        <option key={o.value} value={o.value}>{o.labelPl}</option>
      ))}
    </select>
  )
}
